import { Cause, type Effect, Exit, ManagedRuntime, SchemaIssue } from 'effect'
import { FetchHttpClient, type HttpClient } from 'effect/http'

const apiClientRuntime = ManagedRuntime.make(FetchHttpClient.layer)
const formatIssue = SchemaIssue.makeFormatterDefault()

type ApiRequestResult<A> = { data: A } | { error: { status: number; data: unknown } }

const errorMessage = (error: unknown) => {
  if (SchemaIssue.isIssue(error)) {
    return formatIssue(error)
  }
  return error instanceof Error ? error.message : error
}

export const runApiRequest = async <A, E>(
  effect: Effect.Effect<A, E, HttpClient.HttpClient>,
): Promise<ApiRequestResult<A>> =>
  Exit.match(await apiClientRuntime.runPromiseExit(effect), {
    onSuccess: (data) => ({ data }),
    onFailure: (cause) => ({ error: { status: 500, data: errorMessage(Cause.squash(cause)) } }),
  })
